export enum PaymentStatus {
  Awaiting,
  Completed,
  NotApplicable
}
